<template>
  <div class="gw_home">
    <!--swiper-->
    <div class="swiperContainer">
      <!--第一页-->
      <div class="gw_homeTop">
        <div class="gw_videoContainer">
          <video autoplay="autoplay"  muted id="myVideo" poster="../assets/video/shipin.jpg">
            <source src="../assets/video/shipin.mp4" type="video/mp4">
            您的浏览器不支持video标签
          </video>
          <transition name="fade">
            <div class="video_poster" v-show="videoPoster"></div>
          </transition>
        </div>
        <div class="gw_homeTopmodel">
          <div class="gw_homeTopBox">
            <div class="gw_title">打造信息网络安全为数字经济保驾护航</div>
            <div class="gw_title2">基于自主研发的高并发网络安全主动发现技术，先一步发现问题，并提供完整解决方案。</div>
            <transition name="fade">
              <div class="video_playBtn"><span @click="playVideo" v-show="videoPlayBtn"></span></div>
            </transition>
            <div class="startbtn_wrap">
              <!--<div class="gw_startbtn" @click="startNow">立即开始</div>-->
            </div>
            <div class="gw_nextPage" @click="goToTop">
              <!--<div class="gw_nextBtn"></div>-->
            </div>
          </div>
        </div>
      </div>
      <!--第二页-->
      <div class="gw_homeBottom" id="gw_homeNextPage">
        <div class="mainContainer" style="display:none">
          <div class="gw_homeBottomTitle flex_center"><span>多种安全产品服务 赋能社会安全</span></div>
          <div class="gw_swiperSlidebox flex_space">
            <div class="gw_Slide gw_slide1" @click="goToslide('/product1')">
              <img src="../assets/img/home/slide1.jpg" alt="">
              <div class="imgModel">
              </div>
              <div class="gw_slideModel">
                <h4>漏洞扫描 免费 <i></i></h4>
                <p>先黑客一步发现问题，并快速解决。</p>
              </div>
            </div>
            <div class="gw_Slide gw_slide2" @click="goToslide('/product3')">
              <img src="../assets/img/home/slide2.jpg" alt="">
              <div class="imgModel">
              </div>
              <div class="gw_slideModel">
                <h4>专家服务</h4>
                <p>资深安全专家，提供最优解决方案。</p>
              </div>
            </div>
            <div class="gw_Slide gw_slide3" @click="goToslide('/solution1')">
              <img src="../assets/img/home/slide3.jpg" alt="">
              <div class="imgModel">
              </div>
              <div class="gw_slideModel">
                <h4>未备案域名阻断系统</h4>
                <p>封禁未备案域名，促进网站安全建设。</p>
              </div>
            </div>
            <div class="gw_Slide gw_slide4" @click="goToslide('/solution2')">
              <img src="../assets/img/home/slide4.jpg" alt="">
              <div class="imgModel">
              </div>
              <div class="gw_slideModel">
                <h4>网站全时安全管控平台</h4>
                <p>一键管控，秒级响应，网站更安全。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="gw_homefooter">
          <div class="gw_footerAdv">
            <canvas id="canvas" style="width:100%;height:100%;"></canvas>
            <div class="gw_footerAdvtitle flex_center"></div>
          </div>
          <div class="gw_homefooterBox">
            <footBar></footBar>
          </div>
        </div>
      </div>
    </div>
    <!--返回顶部-->
    <returnTop></returnTop>
  </div>
</template>

<script>
  import footBar from '../components/footerbar'
  import returnTop from '../components/returnTop'
  import {getCanvas,startAtonce} from '../api/common'

  export default {
    name: "home",
    data() {
      return {
        swiperOption: {
          scrollbar: '.gw_homeBottom',
          direction: 'vertical',
          slidesPerView: 1,
          speed: 1000,
          mousewheel: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.gw_nextPage'
          },
          on: {
            //监听滑动切换事件
            slideChange: () => {
              let myVideo = document.getElementById("myVideo");
              myVideo.pause();
              this.videoPlayBtn = true;
            }
          }
        },
        myVideo: null,
        videoPlayBtn: false,
        videoPoster: false
      }
    },
    components: {
      footBar,returnTop
    },
    mounted() {
      getCanvas('canvas');
      this.showVideoPoster();
      window.addEventListener('scroll',this.scrollToNextpage);
    },
    destroyed(){
      window.removeEventListener('scroll',this.scrollToNextpage);
    },
    methods: {
      startNow(){
        //立即开始
        startAtonce(()=>{
          this.$bus.$emit('login');
        },()=>{
          this.$router.push('/mySite');
        });
      },
      goToslide(url){
        //跳转至漏洞扫描
        this.$router.push(url);
        window.scrollTo({
          top:0
        })
      },
      scrollToNextpage(){
        //鼠标滚动到第二页时视频停止播放
        let offset = document.getElementById('gw_homeNextPage').offsetTop;
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        let top_value = offset-scrollTop;
        let myVideo = document.getElementById("myVideo");
        if(top_value<=10){
          myVideo.pause();
          this.videoPlayBtn = true;
        }
      },
      goToTop(){
        //点击第一页的下一页按钮跳转至第二页
        let offset = document.getElementById('gw_homeNextPage').offsetTop;
        window.scrollTo({
          top:offset,
          behavior:'smooth'
        });
        let myVideo = document.getElementById("myVideo");
        myVideo.pause();
        this.videoPlayBtn = true;
      },
      playVideo() {
        //视频播放
        this.videoPlayBtn = false;
        this.videoPoster = false;
        this.myVideo.play();
      },
      showVideoPoster() {
        this.myVideo = document.getElementById("myVideo");
        var self = this;
        this.myVideo.addEventListener('ended', function () {
          self.videoPoster = true;
          self.videoPlayBtn = true;
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  @mixin borderRadius($border) {
    -moz-border-radius: $border;
    -webkit-border-radius: $border;
    border-radius: $border;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s linear;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .gw_home /deep/ .swiperContainer {
    .swiper-pagination-bullet {
      background: #ccc;
    }
    .swiper-pagination-bullet-active {
      background: #007aff;
    }
    .el-icon-arrow-down:before {
      color: #fff;
      font-size: 29px;
      cursor: pointer;
    }
  }

  @media only screen and (min-width: 1366px) and (max-width: 1441px) {
    /*第一屏*/
    .gw_homeTopmodel {
      .gw_homeTopBox {
        /*padding-top: 226px;*/
        .gw_title {
          font-size: 50px;
        }
        .gw_title2 {
          font-size: 20px;
          width: 763px;
          margin-top: 27px;
          margin-bottom: 25px;
        }
        .video_playBtn {
          height: 30px;
          span {
            width: 24.55px;
            height: 24.55px;
            background: url("../assets/product.svg") no-repeat -805px -244px;
          }
        }
        .startbtn_wrap {
          margin-top: 86px;
          margin-bottom: 72px;
        }
        .gw_startbtn {
          width: 126px;
          height: 42px;
          line-height: 42px;
          font-size: 14px;
          border-radius: 1.4px;
        }
        .gw_nextPage {
          width: 20.8px;
          height: 18.35px;
          background: url("../assets/product.svg") no-repeat -743px -246px;
        }
      }
    }
    /*第二屏*/
    .gw_homeBottom {
      .gw_homeBottomTitle {
        font-size: 26px !important;
        padding-top: 35px !important;
        padding-bottom: 31px !important;
      }
      .gw_swiperSlidebox {
        width: 1009px;
        margin: 0 auto;
        .gw_Slide {
          width: 233px !important;
          height: 336px !important;
          .gw_slideModel {
            padding: 10px !important;
            h4 {
              font-size: 14px !important;
            }
            p {
              font-size: 12px !important;
            }
          }
        }
      }
      .gw_homefooter {
        height: 220px !important;
        .gw_footerAdv {
          height: 100px !important;
          .gw_footerAdvtitle {
            span {
              font-size: 24px;
            }
          }
        }
        .gw_homefooterBox {
          height: 120px !important;
        }
      }
    }
  }

  @media only screen and (min-width: 1450px) and (max-width: 1685px){
    .gw_homeTopmodel {
      .gw_homeTopBox {
        /*padding-top: 220px !important;*/
        .startbtn_wrap {
          margin-top: 80px;
          margin-bottom: 72px;
        }
      }
    }
  }

  .gw_homeTopBox {
    /*padding-top: 320px;*/
    box-sizing: border-box;
    /*position: relative;*/
    width:1200px;
    position:absolute;
    left:50%;
    margin-left:-600px;
    bottom:60px;
    .gw_title {
      font-size: 60px;
      color: #FFFFFF;
      font-family: 'pingfangBold';
    }
    .gw_title2 {
      width: 1090px;
      margin: 38px auto 36px;
      font-size: 26px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      font-family: 'pingfangBold';
    }
    .startbtn_wrap {
      margin-top: 124px;
      margin-bottom: 103px;
    }
    .gw_startbtn {
      cursor: pointer;
      margin: 0 auto;
      width: 180px;
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      color: #FFFFFF;
      font-family: 'pingfangBold';
      background: rgba(255, 255, 255, 0.20);
      /*background:red;*/
      border: 1px solid #FFFFFF;
      border-radius: 2px;
      box-sizing: border-box;
    }
    .gw_nextPage {
      margin: 0 auto;
      width: 30px;
      height: 30px;
      background: url("../assets/product.svg") no-repeat -739px -188px;
      cursor: pointer;
    }
    .video_playBtn {
      margin-top: 35px;
      height: 41px;
      line-height: 41px;
      span {
        cursor: pointer;
        display: inline-block;
        width: 36px;
        height: 36px;
        background: url("../assets/product.svg") no-repeat -799px -186px;
      }
    }
  }

  .swiperContainer {
    height: 100vh;
    width:100%;
    .gw_homeTop {
      width:100%;
      height: 100%;
      position: relative;
      background-size: cover;
      overflow: hidden;
      .gw_homeTopmodel {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100%;
        height: 100%;
        background: rgba(34, 34, 34, 0.50);
      }
    }
    .gw_videoContainer {
      position: relative;
      width:100%;
      height:100%;
      overflow: hidden;
      #myVideo{
        min-width: 100%;
        min-height: 100%;
        position:absolute;
        top:50%;
        left:50%;
        -webkit-transform: translate(-50%,-50%);
        -moz-transform: translate(-50%,-50%);
        transform:translate(-50%,-50%);
      }
      .video_poster {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: url('../assets/video/shipin.jpg') no-repeat center;
        background-size: cover;
      }
    }
    .gw_homeBottom {
      /*height: 100%;*/
      position: relative;
      .mainContainer {
        /*padding-top:3.4%;*/
        padding-top: 60px;
        /*width:71% !important;*/
        .gw_homeBottomTitle {
          padding: 45px 0 45px;
          font-size: 36px;
          color: #000000;
        }
        .gw_swiperSlidebox {
          position: relative;
          /*height:40%;*/
          margin-bottom: 90px;
        }
      }
      .gw_homefooter {
        .gw_footerAdv {
          width: 100%;
          /*height:50%;*/
          height: 180px;
          background: #3FA4F8;
          font-size: 36px;
          position: relative;
          color: #FFFFFF;
          .gw_footerAdvtitle {
            width: 1200px;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -600px;
          }
        }
        .gw_homefooterBox {
          /*height:50%;*/
          height: 160px;
        }
      }
      .swiper-container {
        width: 1200px;
        padding: 30px 3px 30px 3px;
        height: 100%;
        box-sizing: border-box;
      }
      .gw_Slide {
        /*width:23%;*/
        /*height:100%;*/
        width: 277px;
        height: 400px;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        transition: all 0.3s linear;
        .imgModel {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, .2);
        }
        .gw_slideModel {
          position: absolute;
          bottom: -24px;
          left: 0;
          width: 100%;
          /*height:60px;*/
          background: rgba(0, 0, 0, 0.65);
          padding: 13px 13px 13px 21px;
          box-sizing: border-box;
          text-align: left;
          transition: all 0.3s linear;
          h4 {
            font-size: 18px;
            color: #FFFFFF;
            font-family: 'pingfangBold';
            display: inline-block;
            line-height: 30px;
            vertical-align: top;
            /*padding-bottom:5px;*/
            border-bottom: 4px solid #3FA4F8;
            i {
              display: inline-block;
              width: 15px;
              height: 19.5px;
              background: url("../assets/img/home/fire.gif") no-repeat center;
              background-size: 100% 100%;
              vertical-align: middle;
            }
          }
          p {
            font-size: 14px;
            color: #fff;
            margin-top: 10px;
            /*visibility: hidden;*/
            opacity: 0;
            transition: all 0.3s linear;
          }
        }
        img {
          transition: all 0.3s linear;
          position: relative;
          top: -25px;
        }
        &:hover {
          transform: scale(1.05, 1.05);
          /*transition: all 0.5s linear;*/
          img {
            transform: scale(0.9);
            /*transition: all 0.5s linear;*/
          }
          .gw_slideModel {
            bottom: 0;
            /*transition: all 0.5s linear;*/
          }
          p {
            visibility: visible;
            opacity: 1;
          }
        }
      }
      .gw_slide1, .gw_slide4 {
        img {
          left: -200px;
        }
      }
      .gw_slide2 {
        img {
          left: -270px;
        }
      }
      .gw_slide3 {
        img {
          left: -310px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue